import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Invoice } from '../../model/invoice';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { PaymentService } from '../../service/data/payment.service';
import { IDataContext } from '../../../core/component/list/component.interface';
import { PaymentMethodService } from '../../service/data/payment-method.service';
import { LocalDate } from '../../../core/model/local-date';
import { Money } from '../../../core/model/money';
import { IDestroy } from '../../../core/service/command/command-handler-resolver.service';
import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'regulate-from-balance-form',
    templateUrl: './regulate-from-balance-form.component.html',
    styleUrls: ['./regulate-from-balance-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RegulateFromBalanceFormComponent implements IDataContext, IDestroy {
  constructor(
    private _dataService: PaymentService,
    private _modalService: ActionWindowService,
    private _paymentMethodService: PaymentMethodService,
    cf: FormControlExFactory,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      amount: cf.createMandatory('COMMON.AMOUNT', 0),
      accountingDate: cf.createMandatory('ACCOUNT.ACCOUNTING_DATE', LocalDate.today()),
      invoiceId: cf.createHidden(''),
    });
  }

  destroy(): void {
    if (this._sub) {
      this._sub.unsubscribe();
    }
  }

  private _sub: Subscription;

  private _dataContext: { invoiceId: string; invoiceBalance: Money; balance: Money };
  get dataContext(): { invoiceId: string; invoiceBalance: Money; balance: Money } {
    return this._dataContext;
  }
  set dataContext(value: { invoiceId: string; invoiceBalance: Money; balance: Money }) {
    this._dataContext = value;
    if (value.balance.amount < value.invoiceBalance.amount) {
      this.form.controls['amount'].setValue(value.balance);
    } else {
      this.form.controls['amount'].setValue(value.invoiceBalance);
    }
    this.form.controls['invoiceId'].setValue(value.invoiceId);
  }
  readonly form: FormGroup;

  cancel() {
    this._modalService.close();
  }

  working: boolean;

  onSubmit() {
    if (this.form.invalid || this.working) {
      return;
    }

    this.working = true;

    if (this._sub) {
      this._sub.unsubscribe();
    }

    let formValue = this.form.value;
    this._sub = this._dataService
      .regulateFromBalance(formValue.invoiceId, formValue.amount, formValue.accountingDate)
      .pipe(
        catchError(e => {
          this.working = false;
          throw e;
        })
      )
      .subscribe(() => {
        this._modalService.complete(formValue.amount);
        this.working = false;
        this._modalService.close();
      });
  }
}
